export const EVENTS = {
  VIDEO: {
    PLAY: 'movies.video.play',
    CLOSE: 'movies.video.close'
  }
};
